module.exports = "/_next/static/images/img-hero-universe-dffe44c3cb765a6462abc1bb8e4e7966.svg";